import { InfoIcon } from "lucide-react";
import {
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Textarea,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@sfc/ui";

export function FormTextarea<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  className,
  labelClassName,
  textareaClassName,
  control,
  name,
  label,
  hint,
  description,
  ...rest
}: React.ComponentProps<typeof Textarea> &
  Omit<ControllerProps<TFieldValues, TName>, "render"> & {
    labelClassName?: string;
    textareaClassName?: string;
    label?: string;
    hint?: string;
    description?: string;
  }) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          {label && (
            <FormLabel className={labelClassName}>
              {label}
              {hint && (
                <Tooltip>
                  <TooltipTrigger>
                    <InfoIcon className="size-4" />
                  </TooltipTrigger>
                  <TooltipContent className="max-w-sm">{hint}</TooltipContent>
                </Tooltip>
              )}
            </FormLabel>
          )}
          <FormControl>
            <Textarea className={textareaClassName} {...rest} {...field} />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
